import React from 'react';
import KeyboardFormField from '@common/components/keyboardFormField';
import PropTypes from 'prop-types';
import { defaultRegisterFields } from '../constants/defaultRegisterFields';

export const DefaultRegister = ({
  form, setForm, errors,
}) => {
  const onChange = (name, value) => {
    setForm({ ...form, [name]: value });
  };

  return (
    <div className="input-wrapper">
      {defaultRegisterFields.map((item) => {
        const Component = item.custommComponent || KeyboardFormField;
        return (
          <Component
            customCode={form.customPhoneNumber.code}
            readOnly={item.readOnly}
            key={item.name}
            name={item.fieldName}
            value={form[item.name]}
            onChange={(value) => onChange(item.name, value)}
            errorMessage={errors[item.name]}
            type={item.type}
            placeHolder={item.placeHolder}
            maxLength={item.maxLength}
          />
        );
      })}
    </div>
  );
};

DefaultRegister.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func,
  errors: PropTypes.object,
};
